import React from 'react';
import env from "settings/app-settings";
import ReCAPTCHA from "react-google-recaptcha";

import styles from './captcha.module.scss';

export const GoogleRecaptcha = React.forwardRef((props, ref) => {
    const {
        className = styles.recatcha,
        size = "invisible",
        onChange,
        sitekey = env.recatchaKey,
        ...other
    } = props;

    React.useEffect(() => {
        const onSubmitWithReCAPTCHA = async () => {
            const token = await ref?.current?.executeAsync();
            if (token) {
                onChange(token);
            }
        }
        onSubmitWithReCAPTCHA();
    }, [ref, onChange])

    return (

        <ReCAPTCHA
            ref={ref}
            className={className}
            size={size}
            sitekey={sitekey}
            hl="es"
            badge="bottomleft"
            {...other}
        />

    );
});

export default GoogleRecaptcha;
